// ----
// JS for RedeemCode Widget
// ----

var SCM = SCM || {};

SCM.RedeemCode = (function ($) {

    var userInput;
    var submitButton;
    var responseModal;
    var responseMessages;

    return {
        init: init
    };

    // returns true if the feature is enabled, false otherwise
    function init() {
        submitButton = $('#js-redeem-code-button');

        if (submitButton.length) {

            userInput = $('#js-redeem-code-input');
            responseModal = $('#js-redeem-code-modal');
            responseMessages = $('#js-redeem-code-messages');

            submitButton.off('click');
            submitButton.on('click', processRequest);
            return true;
        }

        return false;
    }

    function openModal() {
        if (responseModal.length) {
            $(responseModal).addClass('open');
        }
    }

    function processRequest() {
        var code = $.trim(userInput.val());

        if (code) {
        
            // prevent someone from spamming this button
            submitButton.off('click');
            $('body').addClass('on-canvas');

            $.ajax({
                type: 'POST',
                url: '/UserDashboard/RedeemCode',
                cache: false,
                data: JSON.stringify({ 'productCode' : code }),
                contentType: 'application/json'
            }).done(function (data) {
                if (data) {
                    responseMessages.html(data.Messages[0]);
                    openModal();
                }
                else {
                    alert('Unable to process your request, please contact customer service');
                }
                init();
            }).fail(function () {
                alert('Unable to process your request, please contact customer service');
            });
        }
    }
})(jQuery);

jQuery(function () {
    SCM.RedeemCode.init();
});